import type { NextPage, GetServerSideProps, InferGetServerSidePropsType } from 'next'

// import { useRouter } from 'next/router'
// import { useState, useEffect, useCallback, useRef } from 'react'

import { ProjectModel } from '@/modules/project'
import type { Item, Pagination } from '@/modules/project'

import SEO from '@/modules/seo'
import Page from '@/components/pages/opinion/participation/item'
import ProjectResidentsOpinion from '@/modules/projectResidentsOpinion'
import type { GetItemsResult } from '@/modules/projectResidentsOpinion/interface'


interface IProps {
  projectIdx: number;
  item: Item;
  opinion: {
    items: GetItemsResult["items"];
    // pagination: Pagination;
  }
}

export const getServerSideProps: GetServerSideProps<IProps> = async (context) => {
  const projectIdx = parseInt((context.params && context.params.projectIdx || context.query && context.query.projectIdx) as string, 10);
  const model = new ProjectModel();
  const result = await model.getItem({ idx: projectIdx });

  const ProjectResidentsOpinionModel = new ProjectResidentsOpinion();
  const opinionItems = await ProjectResidentsOpinionModel.getItems(projectIdx);

  return {
    props: {
      projectIdx,
      item: result.item,
      opinion: {
        items: opinionItems.items,
      },
    }
  }
}


const Component: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (props) => {
  const pageTitle = `주민의견 제출`

  return (
    <div className='flex flex-col justify-center'>
      <SEO title={pageTitle} />
      <Page {...props} />
    </div>
  )
}

export default Component
